module.exports = __webpack_public_path__ + "static/media/AD_DL.77033d57.png";